import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import Accordion from './expansion-panel';
import objectAccessor from '../util';
import makeStyles from '../table-styles';
import { uniqueId } from '../../../globals/utils';

export interface HeadCell {
  disablePadding: boolean;
  id: string;
  label: string;
  numeric: boolean;
  accessor: string;
}

export interface SortByOptions {
  id: string;
  label: string;
}

type expandableRowProperties = {
  row: object;
  handleClick: Function;
  isItemSelected: boolean;
  labelId: string;
  headCells: HeadCell[];
  expandableData: object;
  id: number;
  selectableRows?: Function;
  openRows: number[];
  setOpenRows: Function;
  rowAlignment?: 'inherit' | 'left' | 'center' | 'right' | 'justify';
  isDownloadable?: boolean;
  onClickOfDownload?: Function;
  isDownloadDisabled?: boolean;
  downloadFace?: any;
  downloadOutline?: boolean;
  downloadStyle?: any;
};

const ExpandableRow = (properties: expandableRowProperties) => {
  const location = useLocation();
  const {
    id,
    labelId,
    headCells,
    row,
    expandableData,
    handleClick,
    isItemSelected,
    selectableRows,
    openRows,
    setOpenRows,
    rowAlignment,
    isDownloadable,
    onClickOfDownload,
    isDownloadDisabled,
    downloadFace,
    downloadOutline,
    downloadStyle,
  } = properties;
  const open = openRows.includes(id);

  const toggleOpenRows = () => {
    const openRowIndex = openRows.findIndex((openRow) => openRow === id);
    const rowsCopy = [...openRows];
    if (openRowIndex > -1) rowsCopy.splice(openRowIndex, 1);
    else rowsCopy.push(id);
    setOpenRows(rowsCopy);
  };
  const classes = makeStyles();
  return (
    <>
      <TableRow
        classes={{ selected: classes.tableRow }}
        className={classes.tableRow}
        hover
        role="checkbox"
        aria-checked={isItemSelected}
        tabIndex={-1}
        key={id}
        selected={isItemSelected}
      >
        {selectableRows ? (
          <TableCell padding="checkbox">
            <Checkbox
              checked={isItemSelected}
              onClick={(event) => handleClick(event, id)}
              inputProps={{ 'aria-labelledby': labelId }}
            />
          </TableCell>
        ) : (
          <></>
        )}
        {headCells.map((cellRow: any) => {
          const cellValue = cellRow ? objectAccessor(properties, cellRow.accessor) : null;
          return (
            <TableCell
              key={`${uniqueId()}`}
              className={classes.tableCell}
              align={rowAlignment || 'center'}
            >
              {cellValue && cellValue.uri ? (
                <Link to={`${location.pathname}${cellValue.uri}`}>{cellValue.value}</Link>
              ) : (
                cellValue && cellValue
              )}
            </TableCell>
          );
        })}
        {Object.keys(expandableData).length === 0 ? (
          <></>
        ) : (
          <TableCell align="center" className={classes.toggleArrow} onClick={toggleOpenRows}>
            {open ? <ArrowDropUp /> : <ArrowDropDown />}
          </TableCell>
        )}
        {!isDownloadable ? (
          <></>
        ) : (
          <TableCell align="center" className={classes.toggleArrow}>
            {onClickOfDownload && (
              <Button
                onClick={(event: any) => onClickOfDownload(event, id)}
                variant={
                  downloadOutline === true || downloadOutline === undefined ? 'outlined' : undefined
                }
                className={downloadStyle || classes.sendButton}
                disabled={isDownloadDisabled}
              >
                <Typography variant="button">{downloadFace || 'send file to device'}</Typography>
              </Button>
            )}
          </TableCell>
        )}
      </TableRow>
      {Object.keys(expandableData).length === 0 ? (
        <></>
      ) : (
        <Accordion
          classes={classes}
          col={headCells.length}
          row={row}
          open={open}
          expandableData={expandableData}
        />
      )}
    </>
  );
};
export default ExpandableRow;
